export default "__VITE_ASSET__BuBbOt8m__"